import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "app/api";

export interface GetVerifierRequest {
    GET_VERIFIER: {
        State: string;
    }
}

export interface GetVerifierResponse {
    GET_VERIFIER: {
        status: number;
        data: {
            key: string;
            value: string;
        }
    }
}

export interface GetTokenResponse {
    GET_TOKEN: {
        status: number;
        data: {
            access_token: string,
            expires_in: number,
            id_token: string,
            refresh_token: string,
            scope: string,
            token_type: string
        };
    }
}

export const getVerifierInsw = createAsyncThunk(
    "getVerifierInsw",
    async (data: { State: string }, thunkAPI) => {
        const config = {
            method: "get",
            url: "oauth/insw-verifier",
            params: {
                filter: data
            }
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data);
            }
        );
    }
);


export const getTokenInsw = createAsyncThunk(
    "getTokenInsw",
    async (data: { GET_TOKEN: { Code: string, CodeVerifier: string, State: string } }, thunkAPI) => {
        const config = {
            method: "post",
            url: "oauth/insw-token",
            data
        };

        return api(config).then(
            (res: any) => {
                return res.data;
            },
            (err: any) => {
                return thunkAPI.rejectWithValue(err.response.data);
            }
        );
    }
);

const OAuthSlice = createSlice({
    name: "OAuthSlice",
    initialState: {
        dataVerfier: {
            GET_VERIFIER: {
                data: {
                    key: "",
                    value: ""
                }
            }
        } as GetVerifierResponse,
        dataToken: {
            GET_TOKEN: {
                data: {
                    access_token: "",
                    expires_in: 0,
                    id_token: "",
                    refresh_token: "",
                    scope: "",
                    token_type: ""
                },
                status: 0,
            }
        } as GetTokenResponse,
        isFetchingVerfier: false,
        isSuccessVerfier: false,

        isFetchingToken: false,
        isSuccessToken: false,

        isError: false,
        errorMessage: "" as string,
    },
    reducers: {
        clearState: (state, action) => {
            state.isFetchingVerfier = false;
            state.isSuccessVerfier = false;

            state.isFetchingToken = false;
            state.isSuccessToken = false;

            state.isError = false;
            state.errorMessage = "";
        },
    },
    extraReducers: (builder) => {
        // getVerifier
        builder.addCase(getVerifierInsw.fulfilled, (state, { payload }) => {
            state.isFetchingVerfier = false;
            state.dataVerfier = payload;
            state.isSuccessVerfier = true;
            return state;
        });
        builder.addCase(getVerifierInsw.rejected, (state, payload: any) => {
            state.isFetchingVerfier = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getVerifierInsw.pending, (state, action) => {
            state.isFetchingVerfier = true;
        });

        builder.addCase(getTokenInsw.fulfilled, (state, { payload }) => {
            state.isFetchingToken = false;
            state.dataToken = payload;
            state.isSuccessToken = true;
            return state;
        });
        builder.addCase(getTokenInsw.rejected, (state, payload: any) => {
            state.isFetchingToken = false;
            state.isError = true;
            state.errorMessage = payload.payload;
        });
        builder.addCase(getTokenInsw.pending, (state, action) => {
            state.isFetchingToken = true;
        });
    },
});

export const { clearState } = OAuthSlice.actions;
export default OAuthSlice.reducer;
